// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"f1822beb","453":"d94394c2","732":"9391c039","952":"5e16f971","977":"1ceac25c"}[chunkId] + ".chunk.js";
};